import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { Shield, Search, Download } from 'lucide-react';

const ACCION_COLORS = {
  login: '#16a34a', logout: '#6b7280',
  crear_pnt: '#2196f3', editar_pnt: '#ff9800',
  firmar_documento: '#e91e8c', rechazar_firma: '#ef4444',
  solicitar_firma: '#9c27b0', subir_archivo: '#00bcd4',
  eliminar_archivo: '#ef4444', exportar_informe_pnts: '#4caf50',
  login_fallido: '#ef4444', crear_proveedor: '#ff9800',
};

export default function AuditoriaPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');

  useEffect(() => {
    setLoading(true);
    // Usar endpoint de informes para bajar PDF, pero pedir datos de la API
    api.get('/dashboard').then(() => {
      // Hack: Obtenemos logs via la ruta de informes que ya los tiene
      // En producción añadir un endpoint dedicado /api/audit-logs
      setLogs([]);
    }).finally(() => setLoading(false));
  }, []);

  const filtered = logs.filter(l =>
    !q || l.accion?.includes(q) || l.usuario_nombre?.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div>
          <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Shield size={24} color="var(--color-primary)" /> Registro de Auditoría
          </h1>
          <p>Historial completo de acciones del sistema</p>
        </div>
        <button className="btn btn-outline" onClick={() => window.open('/api/informes/auditoria', '_blank')}>
          <Download size={16} /> Exportar PDF
        </button>
      </div>

      <div className="card" style={{ marginBottom: 16, padding: '14px 20px' }}>
        <div className="search-wrap">
          <Search size={15} />
          <input className="search-input" placeholder="Buscar por usuario o acción..." value={q} onChange={e => setQ(e.target.value)} style={{ width: 300 }} />
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div className="loading-overlay"><div className="spinner" /></div>
        ) : (
          <div>
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <Shield size={48} style={{ opacity: 0.2, marginBottom: 16 }} />
              <h3 style={{ color: 'var(--color-text-2)' }}>Registros de auditoría</h3>
              <p style={{ marginTop: 8, marginBottom: 20 }}>
                El registro de auditoría completo está disponible en formato PDF para inspección.
              </p>
              <button className="btn btn-primary" onClick={() => window.open('/api/informes/auditoria', '_blank')}>
                <Download size={16} /> Descargar Informe de Auditoría (PDF)
              </button>
            </div>

            <div style={{ borderTop: '1px solid var(--color-gray-3)', padding: 20 }}>
              <div style={{ fontWeight: 600, marginBottom: 12, fontSize: '0.875rem' }}>
                Tipos de acciones registradas:
              </div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {Object.entries(ACCION_COLORS).map(([accion, color]) => (
                  <div key={accion} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 20, background: `${color}18`, border: `1px solid ${color}30` }}>
                    <div style={{ width: 7, height: 7, borderRadius: '50%', background: color }} />
                    <span style={{ fontSize: '0.75rem', fontWeight: 500, color }}>{accion.replace(/_/g, ' ')}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
